/** برچسب قابل‌نمایش دلیل رد */
export const getRejectReasonLabel = (reason) => {
  if (!reason) return '—';
  if (reason.is_other) return 'سایر';
  const name = String(reason.name || '').trim();
  if (!name) return '—';
  if (/^modules\./i.test(name) || /^other$/i.test(name)) return 'سایر';
  return name;
};

export const isRejectReasonOther = (reason) => {
  if (!reason) return false;
  if (reason.is_other) return true;
  const name = String(reason.name || '').trim();
  return /^modules\./i.test(name) || /^other$/i.test(name);
};

/** مرتب‌سازی: سایر در انتها */
export const sortRejectReasons = (list = []) =>
  [...(list || [])].sort((a, b) => {
    const pa = Number(a?.priority ?? (isRejectReasonOther(a) ? 9999 : 0));
    const pb = Number(b?.priority ?? (isRejectReasonOther(b) ? 9999 : 0));
    return pa - pb;
  });

/**
 * ساخت payload رد برای change-step / change-stage
 * @returns {{ reject_reason_id: number, reject_reason?: string } | null}
 */
export const buildRejectPayload = ({ reasonId, reasonText, reasons = [] } = {}) => {
  if (reasonId == null || reasonId === '') return null;
  const selected = (reasons || []).find((r) => String(r.id) === String(reasonId));
  const payload = { reject_reason_id: Number(reasonId) };
  if (isRejectReasonOther(selected)) {
    const text = String(reasonText || '').trim();
    if (!text) return null;
    payload.reject_reason = text;
  }
  return payload;
};

export const validateRejectSelection = ({ reasonId, reasonText, reasons = [] } = {}) => {
  if (reasonId == null || reasonId === '') {
    return 'لطفاً دلیل رد را انتخاب کنید';
  }
  const selected = (reasons || []).find((r) => String(r.id) === String(reasonId));
  if (isRejectReasonOther(selected) && !String(reasonText || '').trim()) {
    return 'لطفاً توضیح دلیل رد را وارد کنید';
  }
  return null;
};
